import api from '@/services/api.js';

export default { 
    getAll(){
        return api.get('/articles'); 
    },
    getOne(id){
        return api.get('/articles/' + id); 
    },
    add(article){
        return api.post('/articles', article);
    },
    update(article){
        return api.put('/articles/' + article.id, article);
    },
    delete(article){
        return api.delete('/articles/' + article.id);
    }
}